import {CartItemEyeglassesType} from 'desktop/pages/cart/types';

const hasPremiumCartItem = (item?: CartItemEyeglassesType): boolean => {
    return item?.isPremium || false;
};

const hasTransSkuCartItem = (item?: CartItemEyeglassesType): boolean => {
    return (item?.sku || '').includes('trans-');
};

/**
 * Provides string with co-pay values
 * @param item - cart item object
 * @param isPremiumItem - boolean value displaying whether the selected eyeglass frame is a premium eyewear frame
 * @param lensColorSku - lenseColor sku string
 * @returns string
 */
export const getCoPayValue = (
    item?: CartItemEyeglassesType,
    isPremiumItem?: boolean,
    lensColorSku?: string,
): string => {
    const isPremiumCartItem = hasPremiumCartItem(item);
    const isTransSkuCartItem = hasTransSkuCartItem(item);
    const isPremiumActiveProduct = isPremiumItem || false;
    const isTransLensSku = (lensColorSku || '').startsWith('trans-');
    if (isPremiumCartItem || isTransSkuCartItem || isPremiumActiveProduct || isTransLensSku) {
        return '30';
    }

    return '15';
};
